var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';
import { BaseComponent } from '../../utils/BaseComponent';
import './toast';
let TrustToastContainer = class TrustToastContainer extends BaseComponent {
    /**
     *
     */
    constructor() {
        super();
        this._toasts = new Map();
        this.del = this.del.bind(this);
        this.add = this.add.bind(this);
    }
    del(id) {
        this._toasts.delete(id);
        this.requestUpdate();
    }
    add(event) {
        const toast = event.detail;
        this._toasts.set(toast.id, toast);
        this.requestUpdate();
        if (toast.duration) {
            setTimeout(() => {
                this.del(toast.id);
            }, toast.duration);
        }
    }
    connectedCallback() {
        super.connectedCallback();
        document.addEventListener('add-trust-toast', this.add);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener('add-trust-toast', this.add);
    }
    render() {
        const toastArray = Array.from(this._toasts.values());
        return html `
      <aside
        class="fixed fixed-ios-fix bottom-16 left-0 right-0 mx-8 sm:mx-16 z-50 pointer-events-none"
      >
        <div
          class="grid grid-cols-1 f-grid auto-rows-auto justify-items-center justify-center mx-auto pointer-events-none"
        >
          ${repeat(toastArray, (toast) => toast.id, (toast) => html `<trust-toast
              class="w-full"
              id="${toast.id}"
              type="${toast.type}"
              text="${toast.text}"
              ?canClose=${toast.canClose}
              @close=${() => this.del(toast.id)}
            >
            </trust-toast>`)}
        </div>
      </aside>
    `;
    }
};
__decorate([
    property()
], TrustToastContainer.prototype, "classNames", void 0);
__decorate([
    state()
], TrustToastContainer.prototype, "_toasts", void 0);
TrustToastContainer = __decorate([
    customElement('trust-toast-container')
], TrustToastContainer);
export { TrustToastContainer };
//# sourceMappingURL=toastContainer.js.map